import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
const moment = require("moment");
import { showSuccessSnackbar, showErrorSnackbar } from "../../../redux/slices/snackbar";
import { useDispatch } from "react-redux";
import { useDialog } from "../../../contexts/DialogContext";
import SaveIcon from "@mui/icons-material/Save";
import useScheduleUser from "../../../hooks/useScheduleUser";

import {
  Grid,
  Divider as MuiDivider,
  Box,
  DialogActions,
  Button,
  CircularProgress,
  Typography as MuiTypography,
} from "@mui/material";
import { spacing } from "@mui/system";
import TextField from "@mui/material/TextField";
import { useForm, FormProvider } from "react-hook-form";
import useUser from "../../../hooks/useUser";

function BulkUser(props) {
  const { userId, refreshPage, selectedRows } = props;
  const { addScheduleUser } = useScheduleUser();

  const { getUser, renewUser, isRenewSubmitting } = useUser();
  const dispatch = useDispatch();
  const { unSetDialog, openDialog } = useDialog();

  const methods = useForm();

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = methods;

  const onSubmit = async (data) => {
    try {
      if (selectedRows == 0) {
        return dispatch(showErrorSnackbar("Please select the user"));
      }
      try {
        for (let index in selectedRows) {
          const userDetails = await getUser(selectedRows[index]);
          const givenDate = moment(userDetails.expirationDate);
          const currentDate = moment();

          if (givenDate.isAfter(currentDate)) {
            const expirationDate = moment(userDetails.expirationDate);
            const formattedDate = expirationDate.utc().format("YYYY-MM-DD HH:mm:ss");
            const payload = {
              plan: {
                planId: userDetails.planId,
                planName: userDetails.planName,
              },
              rate: {
                rateId: userDetails.rateId,
                rateName: "",
              },
              radUserId: selectedRows[index],
              scheduleDateStr: formattedDate,
              renewalType: "MANUAL_SCHEDULE",
              scheduleType: "MANUAL_SCHEDULE",
              invoiceStatus: "PAID",
            };
            await addScheduleUser(payload);
          } else {
            const payload = {
              radUserId: selectedRows[index],
              planId: userDetails.planId,
              planName: userDetails.planName,
              oldPlanId: userDetails.planId,
              tenantId: userDetails.tenantId,
              rateId: userDetails.rateId,
              renewalType: "MANUAL",
              renewalCycle: "IMMEDIATE",
              invoiceStatus: "PAID",
            };
            await renewUser(payload);
          }
        }
        //await disconnectUser(selectedRows);
        dispatch(showSuccessSnackbar("Users Renewal Successfully!"));
      } catch (err) {
        dispatch(showErrorSnackbar(err.message));
      }

      refreshPage();
      unSetDialog("bulk_renewal");
    } catch (err) {
      dispatch(showErrorSnackbar("Failed to Renew Users"));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <i>Do you want to Renewal Bulk users?</i>
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              endIcon={isRenewSubmitting ? <CircularProgress size={24} /> : null}
              disabled={false}
            >
              Yes
            </Button>

            <Button variant="text" onClick={() => unSetDialog("bulk_renewal")} color="primary">
              No
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default BulkUser;
